import { TableException } from "./TableException";

export class UnavailableProduct extends TableException {

    constructor ({ sku, name}) {
        super(`O item "${sku} - ${name}" não está mais disponível`);
        this.productName = name;
        this.productSku = sku;
    }

    get variables () {
        return {
            sku: this.productSku,
            name: this.productName
        }
    }

    get template () {
        return "itemNotAvailable";
    }

}
